<template>
    <v-row
        no-gutters
        class="pl-6 pr-8 pt-8"
    >
        <v-col cols="12">
            <AppStoreListHeader
                :item-label="$t('Invoice templates')"
            />
            <v-row
                no-gutters
            >
                <v-col cols="12">
                    <data-table
                        :items="items"
                        :headers="headers"
                        row-clickable
                        @click:row="editTemplate($event.channel)"
                    />
                </v-col>
            </v-row>
        </v-col>
        <EditEmailTemplateDialog
            v-if="template"
            :template="template"
            :errors="errors"
            :show-dialog="Boolean(template)"
            :loader="loader"
            :company-id="selectedAccount.id"
            :header-text="dialogTitle"
            :title-text="template.channel === CONTENT_TEMPLATE_CHANNEL.PDF ? $t('Name') : $t('Subject')"
            :show-placeholders="template.channel === CONTENT_TEMPLATE_CHANNEL.EMAIL"
            :type="template.type"
            :channel="template.channel"
            @cancel="onCancelTemplate"
            @save="onSaveTemplate"
        />
    </v-row>
</template>

<script>
import { $t } from "@/i18n";
import { ref, computed, reactive } from "@vue/composition-api";
import AddButton from "@/components/Buttons/AddButton";
import EditTemplate from "../EditTemplate/Index";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import { CONTENT_TEMPLATE_TYPE, CONTENT_TEMPLATE_CHANNEL } from "../../../helpers/constants";
import AppStoreListHeader from "../../../components/AppStore/AppStoreListHeader";
import EditEmailTemplateDialog from "../../Dialog/EditEmailTemplateDialog/Index"
import Loader from "../../../utility/loader";
import ApiContentTemplate from "@/api/contentTemplate/contentTemplate"

export default {
    name: "BillingDialogInvoiceTemplatesTab",
    components:{
        AddButton,
        EditTemplate,
        AppStoreListHeader,
        EditEmailTemplateDialog
    },
    setup() {
        const { appStoreDialogGetters } = appStoreDialog()
        const template = ref(null);
        const errors = ref({});
        const loader = reactive(new Loader())

        const selectedAccount = computed(() => {
            return appStoreDialogGetters.getSelectedCompany()
        })

        const editTemplate = async (type) => {
            template.value = await ApiContentTemplate.getInvoiceTemplate(type, selectedAccount.value.id)
        }

        const onCancelTemplate = async () => {
            template.value = null;
        }

        const headers = [
            { value: "name", text: $t("Name") },
            { value: "edit", sortable: false }
        ]

        const items = [
            {
                name: $t("PDF templates"),
                channel: CONTENT_TEMPLATE_CHANNEL.PDF
            },
            {
                name: $t("E-mail templates"),
                channel: CONTENT_TEMPLATE_CHANNEL.EMAIL
            }
        ]

        const onSaveTemplate = async (saveTemplate) => {
            loader.withLoader(async () => {
                try {
                    errors.value = {}
                    await ApiContentTemplate.saveInvoiceTemplate(saveTemplate)
                    template.value = null;
                } catch (error) {
                    errors.value = error
                }
            })
        }

        const dialogTitle = computed(() => {
            if (!template.value) {
                return ""
            }

            return template.value.channel === CONTENT_TEMPLATE_CHANNEL.EMAIL ? $t('Edit email template') : $t('Edit PDF template')
        })

        return {
            CONTENT_TEMPLATE_TYPE,
            CONTENT_TEMPLATE_CHANNEL,
            editTemplate,
            onSaveTemplate,
            onCancelTemplate,
            template,
            errors,
            headers,
            items,
            loader,
            selectedAccount,
            dialogTitle
        };
    }
};
</script>
